import React, { useEffect, useState } from "react";
import axios from "axios";

import { useNavigate } from "react-router-dom";

import {
  Users,
  UserCheck,
  ShieldCheck,
  TrendingUp,
  Clock3
} from "lucide-react";

import "./CustomerStats.css";

const CustomerStats = () => {

  const navigate = useNavigate();

  const [stats, setStats] = useState({

    totalCustomers: 0,

    approvedUploads: 0,

    pendingUploads: 0,

    rejectedUploads: 0,

    level4: 0

  });

  useEffect(() => {

    fetchStats();

  }, []);

  const fetchStats = async () => {

    try {

      const res = await axios.get(

        "/api/admin/igniteDashboard"

      );

      if (res.data.success) {

        setStats(res.data.stats);

      }

    }

    catch (err) {

      console.error(err);

    }

  };

  const cards = [

    {

      title: "Total Members",

      value: stats.totalCustomers,

      icon: <Users size={24} />,

      color: "#2563EB"

    },

    {

      title: "Approved Uploads",

      value: stats.approvedUploads,

      icon: <UserCheck size={24} />,

      color: "#22C55E"

    },

    {

      title: "Elite Members",

      value: stats.level4,

      icon: <ShieldCheck size={24} />,

      color: "#9333EA"

    },

    {

      title: "Pending Uploads",

      value: stats.pendingUploads,

      icon: <Clock3 size={24} />,

      color: "#F59E0B",

      onClick: () =>

        navigate(

          "/admin/ignite/pending-uploads"

        )

    },

    {

      title: "Rejected Uploads",

      value: stats.rejectedUploads,

      icon: <TrendingUp size={24} />,

      color: "#EF4444"

    }

  ];

  return (

    <div className="customer-stats">

      {

        cards.map((item, index) => (

          <div

            key={index}

            className="stat-card"

            onClick={item.onClick}

            style={{

              cursor:

                item.onClick

                  ? "pointer"

                  : "default"

            }}

          >

            <div

              className="stat-icon"

              style={{

                background: item.color

              }}

            >

              {item.icon}

            </div>

            <div className="stat-content">

              <h4>

                {item.title}

              </h4>

              <h2>

                {item.value}

              </h2>

            </div>

          </div>

        ))

      }

    </div>

  );

};

export default CustomerStats;